export default "__VITE_ASSET__ZaL6whdG__"